import * as zod from 'zod';

/**
 * Shape for the `llmCredentials` feathers service.
 *
 * `create` carries `apiKey` (input, never echoed back). `find` and `create`
 * return `configured` to report whether a key is on disk — the key value is
 * deliberately write-only and never read back to the client.
 */
export const LlmCredentialsData = zod.object({
  apiKey: zod.string().optional(),
  configured: zod.boolean().optional(),
});

export type LlmCredentialsData = zod.infer<typeof LlmCredentialsData>;
